import request from '@/utils/request'

// 生产环境api路径

// 获取机构基本信息
export function getRes (data) {
  return request({
    data: data,
    url: '/old/organizationAnalysis',
    method: 'post'
  })
}

// 获取学科分布
export function getOrg (data) {
  return request({
    data: data,
    url: '/old/queryOrganization',
    method: 'post'
  })
}

// 开发环境api路径

// // 获取机构基本信息
// export function getOrg (data) {
//   return request({
//     data: data,
//     url: '/api/queryOrganization',
//     method: 'post'
//   })
// }

// // 获取学科分布
// export function getRes (data) {
//   return request({
//     data: data,
//     url: '/api/organizationAnalysis',
//     method: 'post'
//   })
// }



// WEBPACK FOOTER //
// ./src/api/retrieveInst.js